export default function switchDataSet(element, state1 = '', state2 = '') {
    element.dataset.status = (element.dataset.status === state1) ? state2 : state1;
}
;
